<template>
  <div class="bestaetigung">
    <Header />
    <Hero step="bestaetigung" />
    <Status_Success />
    <TicketDownload />
    <Footer />
    <SlideNavigation
      prev-route="daten"
      next-route="tickets"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import Status_Success from '@/components/Status_Success.vue'
import TicketDownload from '@/components/TicketDownload.vue'
import Footer from '@/components/Footer.vue'
import SlideNavigation from '@/components/SlideNavigation.vue'

export default {
  name: 'BestaetigungView',
  components: {
    Header,
    Hero,
    Status_Success,
    TicketDownload,
    Footer,
    SlideNavigation
  },
  data () {
    return {
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>
